import { render, staticRenderFns } from "./customizationContactSection.vue?vue&type=template&id=2facd62c"
import script from "./customizationContactSection.vue?vue&type=script&lang=js"
export * from "./customizationContactSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports